export default {
  "tooManySearchRequests": "検索リクエストが多すぎます",
  "reachedTheLimitForRealTime": "「リアルタイム」検索の上限に達しました。",
  "useTheRecentModeToExploreResults": "その間、「最近」モードを使用すると、当社のデータベースに既に存在するデータに基づいて結果を探索できます。",
  "btnTryLaterAgain": "後で再試行",
  "btnUseRecentMode": "「最近」モードを使用",
  "createNewSequence": "新しいシーケンスを作成",
  "sequenceName": "シーケンス名",
  "enterSequenceName": "シーケンス名を入力",
  "uDontHaveEnoughCredits": "クレジットが不足しています",
  "addMinimumCredits": "検索を続行するために、最低チャージ額である {count} のトップアップクレジットを追加しますか？",
  "btnAddCredits": "クレジットを追加",
  "paymentMethodRequired": "支払い方法が必要です",
  "dontHaveAPaymentMethodLinkedToYourAccount": "アカウントに支払い方法がリンクされていないようです。",
  "pleaseAddYourPaymentMethodToContinue": "続行するには、支払い方法を追加してください。",
  "btnAddNow": "今すぐ追加",
  "creditRunningLow": "クレジットが少なくなっています！",
  "yourCreditIsRunningLow": "クレジットが少なくなっており、自動トップアップを処理できませんでした。",
  "pleaseManuallyTopupYourCredit": "サービスの中断を避けるため、手動でクレジットをチャージしてください。",
  "btnTopup": "今すぐチャージ",
  "uHaveReachedYourLimit": "上限に達しました",
  "subscriptionTiers": "サブスクリプションティア",
  "switchPlansSeamlessly": "シームレスにプランを切り替えられます。残りのクレジットは、将来使用するためのトップアップクレジットとして移行されます。",
  "tabMonthly": "月額",
  "tabAnnual": "年額",
  "tableFieldCredits": "クレジット",
  "tableFieldTopupCredit": "トップアップクレジット",
  "tableFieldPageLimit": "ページ制限",
  "tableFieldExportLimit": "エクスポート制限",
  "tableFieldAPI": "API",
  "tableFieldRolePermission": "カスタム役割権限",
  "tableFieldTeamManagement": "チーム管理",
  "tableFieldPrice": "価格 - ユーザー1人あたり、月額請求",
  "tableFieldFeatures": "機能",
  "titleTiers": "ティア",
  "btnChangePlan": "プランを変更",
  "btnCurrentPlan": "現在",
  "upgradeToUnlockThisFeature": "この機能をロック解除するにはアップグレードしてください",
  "thisFeatureIsAvailableOnlyForUpgradedPlanUsers": "この機能は、アップグレードされたプランのユーザーのみが利用できます。",
  "upgradeYourPlanToEnjoyEnhancedFunctionality": "プランをアップグレードして、強化された機能をお楽しみいただき、ニーズに合わせた可能性をさらに広げてください。",
  "btnBack": "戻る",
  "btnUpgradeNow": "今すぐアップグレード"
}